import request from '@/utils/request'

/** 用户登录 */
export function loginsms(data, headers) {
    return request({
        url: 'fa83e12de4c499127b',
        method: 'post',
        data,
        headers,
    })
}

/**
 * 发送短信验证码
 * @param {*} data
 * @returns
 */
export function getSmscode(data, headers) {
    return request({
        url: '8eabedd76d2fc673c72',
        method: 'post',
        data,
        headers,
    })
}

/**
 * 设置密码
 * @param {*} data
 * @returns
 */
export function setPassword(data, headers) {
    return request({
        url: 'c633c7dff90cbf1f4d',
        method: 'post',
        data,
        headers,
    })
}

/**
 * 密码登录
 * @param {*} data
 * @returns
 */
export function loginPassword(data, headers) {
    return request({
        url: 'c86c8750cb6f407deb',
        method: 'post',
        data,
        headers,
    })
}

/**
 * 退出登录
 * @param {*} data
 * @returns
 */
export function authLogout(data, headers) {
    return request({
        url: '7ccfb0d04986748b53',
        method: 'post',
        data,
        headers,
    })
}

